exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".empty-state-empty-state-4bp0yZ8ymwr{flex-direction:column;justify-content:center;min-height:100%;flex-grow:1;text-align:center}.empty-state-regular-image-2tiLummImwr,.empty-state-large-image-JcROAdmtmwr{margin-bottom:20px;width:200px;height:auto}html[data-supports-mobile=true] .empty-state-regular-image-2tiLummImwr{margin-bottom:16px;width:120px;height:auto}@media (max-width: 767px){html[data-supports-mobile=true] .empty-state-regular-image-2tiLummImwr{width:80px}}@media (max-width: 767px){html[data-supports-mobile=true] .empty-state-large-image-JcROAdmtmwr{margin-bottom:16px;width:120px;height:auto}}@media (max-width: 767px){html[data-supports-mobile=true] .empty-state-huge-image-2hrEHMsEmwr{margin-bottom:16px;width:240px;height:auto}}.empty-state-button-row-4wsTC0zZmwr{display:flex;flex-direction:row;justify-content:center;align-items:center}.empty-state-button-row-4wsTC0zZmwr>*{margin-left:6px;margin-right:6px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"empty-state": "empty-state-empty-state-4bp0yZ8ymwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["vertically-center"] + "",
	"emptyState": "empty-state-empty-state-4bp0yZ8ymwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["vertically-center"] + "",
	"regular-image": "empty-state-regular-image-2tiLummImwr",
	"regularImage": "empty-state-regular-image-2tiLummImwr",
	"large-image": "empty-state-large-image-JcROAdmtmwr",
	"largeImage": "empty-state-large-image-JcROAdmtmwr",
	"huge-image": "empty-state-huge-image-2hrEHMsEmwr",
	"hugeImage": "empty-state-huge-image-2hrEHMsEmwr",
	"button-row": "empty-state-button-row-4wsTC0zZmwr",
	"buttonRow": "empty-state-button-row-4wsTC0zZmwr"
};